export default __webpack_public_path__ + "static/media/burrito.2b2727b4.png";